const generateShareLink = () => {
    return Promise.resolve({ url: window.location.href });
}

const loadShareLink = (code) => {
    if(origin.indexOf("localhost") === -1){
        return new Promise(function (resolve, reject) {
            window.IMWC.lizard.getShortenerData(code).then(function(r) {
                resolve(r.data)
            })
        });
    }
    else{
        return new Promise(function (resolve, reject) {
            resolve("");
        });
    }
}

export {generateShareLink, loadShareLink}

